<template>
  <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form>
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="工单编号" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="投诉类型" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="所属项目" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="">
                <a-input v-model="table.search.work_no" placeholder="请输入工单编号" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <a-cascader :options="table.initData.categoryOptions" placeholder="请选择投诉类型"
                  v-model="table.search.category_id" change-on-select />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <a-select placeholder="请选择所属项目" v-model="table.search.community_id">
                  <a-select-option :value="value.id" v-for="value in projectOptions" :key="value.id">{{ value.name
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="联系人" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="联系电话" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="工单状态" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="">
                <a-input v-model="table.search.contacts" placeholder="请输入联系人" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <a-input v-model="table.search.mobile" placeholder="请输入联系电话" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <a-select placeholder="请选择工单状态" v-model="table.search.status">
                  <a-select-option value="-1">已取消</a-select-option>
                  <a-select-option value="0">待分配</a-select-option>
                  <a-select-option value="1">已分配</a-select-option>
                  <a-select-option value="2">待处理</a-select-option>
                  <a-select-option value="3">处理中</a-select-option>
                  <a-select-option value="4">未办结</a-select-option>
                  <a-select-option value="5">已办结</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48" style="margin-top: 20px">
            <a-col :md="24 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' } || {}">
                <a-button type="primary" @click="toSearch" style="font-style: italic">查询</a-button>
                <a-button style="margin-left: 8px; font-style: italic" @click="resetSearch">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator" style="margin: 20px 0">
        <a-button type="primary" icon="plus" @click="toCreate">新增工单</a-button>
        <!-- <a-dropdown>
          <a-menu slot="overlay">
            <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>
            <a-menu-item key="2"><a-icon type="lock" />上架</a-menu-item>
            <a-menu-item key="2"><a-icon type="lock" />下架</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作 <a-icon type="down" />
          </a-button>
        </a-dropdown> -->
      </div>
      <!-- 表格 -->
      <a-spin tip="加载中..." :spinning="table.loading">
        <a-table :columns="columns" :data-source="table.data" rowKey="id" :pagination="table.page"
          @change="handlePageChange">
          <span slot="status" slot-scope="status">
            {{ getStatus(status) }}
          </span>
          <!-- 投诉来源 -->
          <span slot="source" slot-scope="source">
            {{ source == 1 ? "APP" : source == 2 ? "电话" : "现场" }}
          </span>
          <!-- 投诉类型 -->
          <span slot="category" slot-scope="category">
            {{ category.name }}
          </span>
          <!-- 所属项目 -->
          <span slot="community" slot-scope="community">
            {{ community ? community.name : '暂无信息' }}
          </span>
          <!-- 处理人 -->
          <span slot="staff" slot-scope="staff">
            {{ staff == null ? "---" : staff.name }}
          </span>
          <span slot="images" slot-scope="data">
            <viewer :images="data.images">
              <img v-for="src in data.images" :key="src" :src="src" width="30" height="30"
                style="margin:0 3px;cursor:pointer">
            </viewer>
          </span>
          <span slot="action" slot-scope="text, data">
            <template>
              <a @click="handleCheck(data)">查看</a>
              <a-divider type="vertical" v-if="data.status != -1 && data.status != 5" />
              <a @click="handleDispose(data)" v-if="data.status != -1 && data.status != 5">{{
                actionStr(data.status) }}</a>
              <a-divider type="vertical" v-if="data.status != -1 && data.status != 5" />
              <a @click="handleCancel(data)" v-if="data.status != -1 && data.status != 5">关闭</a>
            </template>
          </span>
        </a-table>
      </a-spin>
      <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal"
        destroy-on-close centered>
        <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
          <a-form-model-item label="是否解决">
            <a-radio-group v-model="modal.subData.return_status" prop="return_status">
              <a-radio :value="1">已解决</a-radio>
              <a-radio :value="2">未解决</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="回访说明">
            <a-textarea v-model="modal.subData.return_explain"></a-textarea>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-card>
    <AssignModal ref="assignRef" @submit="initcomplaintList"></AssignModal>
    <CancelModal ref="cancelRef" @submit="initcomplaintList"></CancelModal>
  </div>
</template>

<script>
import complaintListService from "@/io/complaint/complaintList.js";
import complaintTypeService from "@/io/complaint/complaintType.js";
import CommunityService from "@/io/community.js";
import AssignModal from './modules/assign'
import CancelModal from './modules/cancel'

// 表头
export default {
  name: "complaintListPage",
  components: {
    AssignModal,
    CancelModal
  },
  data() {
    let self = this;
    return {
      modal: {
        title: "回访工单",
        show: false,
        loading: false,
        // 0新增，1编辑
        type: 0,
        subData: {
          return_status: 1,
          return_explain: null,
          id: null
        },
      },
      form: {},
      rules: {
        return_status: [
          {
            required: true,
            message: '请选择解决状态'
          }
        ]
      },
      projectOptions: [],
      community_id: null,
      columns: [
        {
          title: "工单编号",
          dataIndex: "work_no",
          key: "work_no",
        },
        {
          title: "投诉时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        // {
        //   title: "投诉来源",
        //   dataIndex: "source",
        //   key: "source",
        //   scopedSlots: { customRender: "source" },
        // },
        {
          title: "投诉类型",
          dataIndex: "category",
          key: "category",
          scopedSlots: { customRender: "category" },
        },
        {
          title: "所属项目",
          key: "community",
          dataIndex: "community",
          scopedSlots: { customRender: "community" },
        },
        {
          title: "联系人",
          key: "contacts",
          dataIndex: "contacts",
          //   scopedSlots: { customRender: "status" },
        },
        {
          title: "联系电话",
          key: "mobile",
          dataIndex: "mobile",
          //   scopedSlots: { customRender: "status" },
        },
        {
          title: "处理人",
          key: "staff",
          dataIndex: "staff",
          scopedSlots: { customRender: "staff" },
        },
        {
          title: "图片",
          key: "images",
          scopedSlots: { customRender: "images" },
        },
        {
          title: "工单状态",
          key: "status",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
        },

        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      table: {
        loading: false,
        data: [],
        search: {
          community_id: [],
          work_no: null,
          category_id: [],
          contacts: null,
          mobile: null,
          status: [],
          staff_id: null,
        },
        initData: {
          categoryOptions: [],
        },
        page: {
          total: 10,
          current: 1,
          pageSize: 10,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal() {
            return `共${self.table.page.total}条`;
          },
        },
      },
    };
  },
  activated() {
    this.initcomplaintList();
  },
  mounted() {
    this.initCategoryData();
    this.initProject();
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      };
    },
  },
  methods: {
    //   转换状态文本
    actionStr(status) {
      let strStatus = "";
      switch (status) {
        case -1:
          strStatus = "查看详情";
          break;
        case 0:
          strStatus = "分配";
          break;
        case 1:
          strStatus = "处理";
          break;
        case 2:
          strStatus = "办结";
          break;
        case 3:
          strStatus = "回访";
          break;
        case 4:
          strStatus = "完结";
          break;
        case 5:
          strStatus = "删除";
          break;
        default:
          strStatus = "查看详情";
          break;
      }
      return strStatus;
    },
    getStatus(status) {
      let strStatus = "";
      switch (status) {
        case -1:
          strStatus = "已取消";
          break;
        case 0:
          strStatus = "待分配";
          break;
        case 1:
          strStatus = "待处理";
          break;
        case 2:
          strStatus = "处理中";
          break;
        case 3:
          strStatus = "已办结";
          break;
        case 4:
          strStatus = "已确认";
          break;
        case 5:
          strStatus = "已完结";
          break;
        default:
          strStatus = "暂无信息";
          break;
      }
      return strStatus;
    },
    //   工单列表数据
    async initcomplaintList() {
      this.table.loading = true;
      const { page, search } = this.table;
      const res = await complaintListService.list(
        search.work_no,
        search.category_id[search.category_id.length - 1],
        this.community_id,
        search.contacts,
        search.mobile,
        search.status,
        search.staff_id,

        page.current,
        page.pageSize
      );
      this.table.data = res.data;
      this.table.page.total = res.meta.pagination.total;
      this.table.loading = false;
    },
    // 初始化工单分类
    async initCategoryData() {
      const res = await complaintTypeService.list();
      this.table.initData.categoryOptions = this.getTypeOptions(res);
      // 假数据
      // const res = this.categoryResData;
      // this.table.initData.categoryOptions = this.getTypeOptions(res);
    },
    // 初始化所属项目
    async initProject() {
      //   const res = await CommunityService.listPage();
      const res = await CommunityService.listPage();
      this.projectOptions = res.map((val) => {
        return {
          ...val,
        };
      });
    },
    // 回访提交
    confirmModal() {
      this.$beforeFormSubmit(this.$refs.form, async () => {
        let { return_status, return_explain, id } = this.modal.subData
        this.modal.loading = true;
        const res = await complaintListService.returnVisit(id, return_status, return_explain)
        this.$afterFormSubmit("回访完成", () => {
          this.modal.show = false;
          this.modal.loading = false;
          this.initcomplaintList()
        });
      });
    },
    // 生成分类数据
    getTypeOptions(data) {
      let reslist = [];
      if (data) {
        data.map((val) => {
          reslist.push({
            value: val.id,
            label: val.name,
            children: val.child.length > 0 ? this.getTypeOptions(val.child) : [],
          });
        });
      }
      return reslist;
    },

    // // 创建工单
    toCreate() {
      this.$router.push("/platform/complaintlist/new");
    },
    // 查看详情
    handleCheck(data) {
      this.$router.push(`/platform/complaintlist/new/${data.id}`);
    },
    // // 处理工单状态
    async handleDispose(data) {
      const { status, id } = data
      switch (status) {
        case 0:
          this.openAssign(data)
          break
        case 1:
          await complaintListService.confirm(id);
          this.$message.success("工单状态变更完成");
          this.initcomplaintList()
          break;
        case 2:
          await complaintListService.handleFinish(id);
          this.$message.success("工单状态变更完成");
          this.initcomplaintList()
          break;
        case 3:
          this.modal.show = true;
          this.modal.subData.id = id
          break;
        case 4:
          await complaintListService.finish(id);
          this.$message.success("工单状态变更完成");
          this.initcomplaintList()
          break;
        default:
          this.$message.info("工单状态信息错误");
          break;
      }
      // this.$message.success("工单状态变更完成");
    },
    // 分配
    openAssign(data) {
      this.$refs.assignRef.open(data)
    },
    // 关闭
    handleCancel(data) {
      this.$refs.cancelRef.open(data)
    },
    handlePageChange(page) {
      this.table.page.current = page.current;
      this.table.page.pageSize = page.pageSize;
      this.initcomplaintList();
    },
    // 搜索
    toSearch() {
      this.table.page.current = 1;
      this.initcomplaintList();
    },
    // 重置
    resetSearch() {
      this.table.search.community_id = [];
      this.table.search.work_no = null;
      this.table.search.category_id = [];
      this.table.search.contacts = null;
      this.table.search.mobile = null;
      this.table.search.status = [];
      this.table.search.staff_id = null;
      this.toSearch()
    },

  },
};
</script>
<style scoped lang="less">
.imgs {
  max-width: 200px;
  overflow: hidden;
  overflow-x: auto;
  max-height: 40px;

  img {
    cursor: pointer;
  }
}
</style>

